export const HOMESTAY_ROOM_TYPE_LIST_ACTION = "HOMESTAY_ROOM_TYPE_ACTION";
export const HOMESTAY_ROOM_TYPE_LIST_SUCCESS = "HOMESTAY_ROOM_TYPE_LIST_SUCCESS";
export const HOMESTAY_ROOM_TYPE_LIST_FAIL = "HOMESTAY_ROOM_TYPE_LIST_FAIL";
export const HOMESTAY_ROOM_TYPE_DETAIL_ACTION = "HOMESTAY_ROOM_TYPE_DETAIL_ACTION";
export const HOMESTAY_ROOM_TYPE_DETAIL_SUCCESS = "HOMESTAY_ROOM_TYPE_DETAIL_SUCCESS";
export const HOMESTAY_ROOM_TYPE_DETAIL_FAIL = "HOMESTAY_ROOM_TYPE_DETAIL_FAIL";
export const HOMESTAY_ROOM_TYPE_FAIL = "HOMESTAY_ROOM_TYPE_FAIL";
export const HOMESTAY_ROOM_TYPE_SAVE_SUCCESS = "HOMESTAY_ROOM_TYPE_SAVE_SUCCESS";
export const HOMESTAY_ROOM_TYPE_SAVE_ACTION = "HOMESTAY_ROOM_TYPE_SAVE_ACTION";
export const HOMESTAY_ROOM_TYPE_SAVE_FAIL = "HOMESTAY_ROOM_TYPE_SAVE_FAIL";

export const HOMESTAY_ROOM_TYPE_CREATE_TRANSLATE_ACTION = "HOMESTAY_ROOM_TYPE_CREATE_TRANSLATE_ACTION";
export const HOMESTAY_ROOM_TYPE_CREATE_TRANSLATE_SUCCESS = "HOMESTAY_ROOM_TYPE_CREATE_TRANSLATE_SUCCESS";

export const HOMESTAY_ROOM_TYPE_UPDATE_TRANSLATE_ACTION = "HOMESTAY_ROOM_TYPE_UPDATE_TRANSLATE_ACTION";
export const HOMESTAY_ROOM_TYPE_UPDATE_TRANSLATE_SUCCESS = "HOMESTAY_ROOM_TYPE_UPDATE_TRANSLATE_SUCCESS";

export const HOMESTAY_ROOM_TYPE_DELETE_TRANSLATE_ACTION = "HOMESTAY_ROOM_TYPE_DELETE_TRANSLATE_ACTION";
export const HOMESTAY_ROOM_TYPE_DELETE_TRANSLATE_SUCCESS = "HOMESTAY_ROOM_TYPE_DELETE_TRANSLATE_SUCCESS";
export const HOMESTAY_ROOM_TYPE_ALL_HOTEL_ACTION = "HOMESTAY_ROOM_TYPE_HOTEL_ALL_ACTION";
export const HOMESTAY_ROOM_TYPE_ALL_HOTEL_SUCCESS = "HOMESTAY_ROOM_TYPE_ALL_HOTEL_SUCCESS";